import numbro from 'numbro/dist/numbro';

const LANGUAJE = 'es-MX';

export default {
  formatTypeConfig(formatType) {
    const type = formatType.toLowerCase().split('').shift();
    const zeros = Number(formatType.replace(type, ''));
    return {
      type,
      zeros,
    };
  },
  format(number, formatType) {
    const formatConfig = this.formatTypeConfig(formatType);
    if (formatConfig.type === 'c') {
      return numbro(number).formatCurrency({
        thousandSeparated: true,
        mantissa: formatConfig.zeros,
      });
    }
    const configs = {
      p: {
        output: 'percent',
        mantissa: formatConfig.zeros,
      },
      n: {
        mantissa: formatConfig.zeros,
        thousandSeparated: true,
      },
    };
    return numbro(number).format(configs[formatConfig.type]);
  },
  unformat(number, lang = LANGUAJE) {
    if (lang) {
      numbro.setLanguage(lang);
    }
    return Number(numbro.unformat(number)) || number;
  },
};

// Config languages
numbro.registerLanguage({
  languageTag: 'es-MX',
  delimiters: {
    thousands: '',
    decimal: '.',
  },
  abbreviations: {
    thousand: 'k',
    million: 'm',
    billion: 'b',
    trillion: 't',
  },
  ordinal: (number) => {
    return number === 1 ? 'o' : 'o';
  },
  currency: {
    symbol: '$',
    position: 'prefix',
    code: 'MXN',
  },
});

numbro.registerLanguage({
  languageTag: 'es-CL',
  delimiters: {
    thousands: '',
    decimal: ',',
  },
  abbreviations: {
    thousand: 'k',
    million: 'm',
    billion: 'b',
    trillion: 't',
  },
  ordinal: (number) => {
    return number === 1 ? 'o' : 'o';
  },
  currency: {
    symbol: '$',
    position: 'postfix',
    code: 'CLP',
  },
});
